<template>
  <span :style="style">{{ data.text }}</span>
</template>

<script>
export default {
  name: 'TextPart',
  props: {
    data: Object,
  },
  computed: {
    style() {
      const { color, size, stroke, weight } = this.data;
      return {
        color: color,
        fontSize: size + 'px',
        textDecoration: stroke === 1 ? 'line-through' : 'none',
        fontWeight: this.getWeight(weight),
      };
    },
  },
  methods: {
    getWeight(weight) {
      switch (weight) {
        case 0:
          return 'normal';
        case 1:
          return 'normal';
        case 2:
          return '500'; // MEDIUM
        case 3:
          return 'bold';
        case 4:
          return 'lighter';
        case 5:
          return 'normal'; // DEMI（暂时只Flutter支持）
        default:
          return 'normal';
      }
    },
  },
};
</script>
